console.log("A0");
import Vue from 'vue'
import router from './router'
import store from './services/store'
import "./assets/css/global.css";

import createApp from '@shopify/app-bridge';
import {Redirect} from '@shopify/app-bridge/actions';

import {getSessionToken, authenticatedFetch } from '@shopify/app-bridge-utils';

import 'bootstrap/dist/css/bootstrap.css'

import App from './App.vue';
import KotobeeApi from './services/api/KotobeeApi';
import JSAlert from 'js-alert';

// var log = console.log;
console.log("A1");
Vue.config.productionTip = false
window.JSAlert = JSAlert;
console.log("A2",process, process.env.NODE_ENV);

(function(){
    if (window.mode=="redirect"){
        const permissionUrl = '/oauth/authorize?client_id=' + window.$apiKey + '&scope=' + window.$scope + '&redirect_uri=' + window.$redirectUri + '&state=' + window.$nonce;
        var url = 'https://' + window.$shopOrigin + '/admin' + permissionUrl;
        // If the current window is the 'parent', change the URL by setting location.href
        if (window.top == window.self) {
            window.location.assign(url);
        // If the current window is the 'child', change the parent's URL with Shopify App Bridge's Redirect action
        } else { 
            const app = createApp({
                apiKey: window.$apiKey,
                shopOrigin: window.$shopOrigin,
                host: window.$host
            });
            Redirect.create(app).dispatch(Redirect.Action.ADMIN_PATH, permissionUrl);
        }
        return;
    }

    if (process.env.NODE_ENV == 'development') {
    const kApi = new KotobeeApi();

        console.log("A3");

        store.commit('setKotobeeApi', kApi);
        console.log("before");
        new Vue({
            router,
            store,
            render: h => h(App)
        }).$mount('#app');
        console.log("after");

    } else { 
        console.log("else");
    const bridge = createApp({
        apiKey: window.$apiKey,
        shopOrigin: window.$shopOrigin,
        host: window.$host
    });
    window.app = bridge;
    
    console.log("A4..");
    console.log("host",window.$host);
    window.S = getSessionToken;
    window.C = createApp;
    getSessionToken(bridge).then(function(sessionToken) {
        console.log("A5");
        const options = {
        authFetch: authenticatedFetch(bridge),
        sessionToken: sessionToken,
        store,
        }
        console.log("A6",options);
        const kApi = new KotobeeApi(options);
        console.log("A7");
        
        store.commit('setKotobeeApi', kApi);
        store.commit('setBridge', bridge);

        console.log("A8");

        new Vue({
        router,
        store,
        render: h => h(App),
        mounted: function(){
            this.$router.replace('/linking');
        }
        }).$mount('#app');

        console.log("A9");
    
    });
    }
})();

//common js functions

window.dateOnly = function(date) {
    var arr = date.split(" ");
    return arr[0] + " " + arr[1] + " " + arr[2] + " " + arr[3];
}

window.phpDateToJS = function(date) {
    date = date.split("+")[0];
    date = date.replace("T", " ");
    var t = date.split(/[- :]/);
    return new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
}

window.dayDifference = function(date, includeSign){
    console.log("dayDifference", date, includeSign);
    //var date = dateOnly(phpDateToJS(serverDate).toUTCString());
    if (!date) return "";
    date = window.phpDateToJS(date);
    //console.log("date", date);
    var today = new Date();
    var timeDiff = date.getTime() - today.getTime();
    if (!includeSign)
        timeDiff = Math.abs(timeDiff);
    //console.log("timeDiff", timeDiff);
    var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    console.log("diffDays", diffDays);
    return diffDays;
}

window.dateFromServer = function(date){
    if (!date) return "-";
    return window.dateOnly(window.phpDateToJS(date).toUTCString());
}